import { createContext } from "react";
import useFeedingReportStore from "../store/useFeedingReportStore";

const AuthContext = createContext({});

export const AuthProvider = ({ children }) => {
    const {auth, setAuth} = useFeedingReportStore();

    return (
        <AuthContext.Provider value={{ auth, setAuth }}>
            {children}
        </AuthContext.Provider>
    )
}

export default AuthContext;